var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.154 -5C116.115 -5 125 3.88543 125 14.8462L125 104.154C125 115.115 116.115 124 105.154 124L15.8462 124C4.88542 124 -4.00001 115.115 -4 104.154L-4 14.8461C-4 3.88542 4.88543 -5.00001 15.8462 -5L105.154 -5Z",
    fill: "url(#paint0_linear_162_610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3672 76.2951C36.8147 85.0544 45.5386 91.2705 55.7951 92.1934L39.4916 63.9526L32.3672 76.293V76.2951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.447 92.2667C60.0881 92.3084 60.7333 92.3376 61.3868 92.3376C71.1902 92.3376 79.8619 87.5059 85.1655 80.0996H52.4229L59.447 92.2667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9973 48.3862L72.6562 76.6897H86.4896C89.6676 72.0104 91.528 66.3643 91.528 60.2818C91.528 56.0452 90.6197 52.0215 88.9973 48.3862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3935 45.7243C83.0378 36.5765 74.0718 30.0577 63.5 29.1577L80.2294 58.1335L87.3935 45.7243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4624 45.1816C29.4326 49.7879 27.6641 55.2961 27.6641 61.222C27.6641 65.728 28.6851 69.9939 30.5059 73.8067L47.0328 45.1816H32.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3683 41.7632L59.1248 29.2183C58.5277 29.1828 57.9284 29.1577 57.3208 29.1577C54.4727 29.1577 51.7227 29.5732 49.121 30.3333C42.6168 32.2313 37.0521 36.326 33.2832 41.7653H66.3683V41.7632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3505 26.4056C84.3391 26.4056 83.5192 27.2255 83.5192 28.2369C83.5192 29.2483 84.3391 30.0682 85.3505 30.0682H89.9292V34.6466C89.9292 35.658 90.7491 36.4779 91.7605 36.4779C92.7719 36.4779 93.5918 35.658 93.5918 34.6466V30.0682H98.1697C99.1811 30.0682 100.001 29.2483 100.001 28.2369C100.001 27.2255 99.1811 26.4056 98.1697 26.4056H93.5918V21.8274C93.5918 20.816 92.7719 19.9961 91.7605 19.9961C90.7491 19.9961 89.9292 20.816 89.9292 21.8274V26.4056H85.3505Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_610",
    x1: -4,
    y1: -5,
    x2: 125,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F73B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F95A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA851"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo7);
export default __webpack_public_path__ + "static/media/logo7.66162effb1b0615f0ede84e1e990aaf8.svg";
export { ForwardRef as ReactComponent };